import React from "react";

const index = () => {
  return <div className=" bg-teal-700">Login</div>;
};

export default index;
